import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LinearLoader } from "../../components/Loader/LinearLoader";
import { getcradleRequest } from "../../redux/admin/actions/admin.actions";
import { EditOutlined } from "@ant-design/icons";
import { editCradleType } from "../../data";
import { ConfirmationModal } from "../../components/Modal/ConfirmationModal";
import styles from "./cradleRequest.module.scss";
import Card2 from "../../components/paymentCard/Card2";
import ModifyForm from "./ModifyForm";

const CradleRequest = () => {
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [modifyModal, setModifyModal] = useState(false);
  const [closeModal, setCloseModal] = useState(false);

  const [updateType, setUpdateType] = useState(false);
  const [dataMatch, setDataMatch] = useState();

  const dispatch = useDispatch();
  const { cradleRequest } = useSelector((state) => state.adminReducer);

  useEffect(() => {
    setLoading(true);
    dispatch(getcradleRequest());
    setLoading(false);
  }, []);

  const headers = [
    { key: "date", label: "Date" },
    { key: "name", label: "Name" },
    { key: "city", label: "City" },
    { key: "state", label: "State" },
    { key: "blood", label: "Blood" },
    { key: "oxygen", label: "Oxygen" },
    { key: "Claim", label: "" },
  ];

  const openEditModal = (item) => {
    setSelectedItem(item);
    setIsModalOpen(true);
  };

  const editHandler = (selectedItem) => {
    // window.localStorage.setItem("editType", type?.label);
    setUpdateType(false);
    setIsModalOpen(false);
    setSelectedItem(selectedItem);
    setModifyModal(true);
  };

  const handleUpdate = () => {
    setModifyModal(false);
    setCloseModal(true);
  };

  return (
    <div>
      <h2 className={styles.Heading}>Cadre Request</h2>
      <section
        style={{
          maxWidth: "90%",
          margin: "auto",
          padding: "10px",
          justifyContent: "center",
        }}
      >
        {loading && <LinearLoader />}
        <table className={styles.Table}>
          <thead>
            <tr className={styles.TableHeadRow}>
              {headers?.map((row) => {
                return <td key={row.key}>{row.label} </td>;
              })}
            </tr>
          </thead>
          <tbody>
            {cradleRequest &&
              cradleRequest?.map((item) => {
                return (
                  <tr key={item.id} className={styles.TableBodyRow}>
                    <td>{item.created}</td>
                    <td>{item.name}</td>
                    <td>{item.city}</td>
                    <td>{item.state}</td>
                    <td>{item.blood}</td>
                    <td>{item.oxygen}</td>
                    <td>
                      <EditOutlined
                        style={{ color: "gray", fontSize: "19px" }}
                        onClick={() => openEditModal(item)}
                      />
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </section>
      {/* Edit Modal */}
      <ConfirmationModal
        open={isModalOpen}
        handleClose={() => setIsModalOpen(false)}
        closemodal={() => setIsModalOpen(false)}
        bgcolor="rgba(255, 255, 255, 0.92)"
        width="60vw"
        instruction={
          <div>
            <h4 className={styles.header2}>
              Sales lead request for the following change in Cadre for{" "}
              {selectedItem?.name}
            </h4>

            <div className={styles.cards}>
              {/* {editCradleType.map((type) => (
                // <Card2
                //   {...type}
                //   key={type.id}
                //   onClick={() => editHandler(type, selectedItem)}
                //   label={"Oxygen"}
                //   text={"Oxygen and Blood"}
                // />
              
              ))} */}
              <div>
                <h5>Oxygen: {selectedItem?.oxygen}</h5>
                <h5>Blood: {selectedItem?.blood}</h5>
              </div>

              <div className="d-flex justify-content-between m-3">
                <div
                  onClick={() => editHandler(selectedItem)}
                  className={styles.button}
                >
                  Proceed
                </div>
              </div>
            </div>
          </div>
        }
      />
      {/* Modify Modal */}
      <ConfirmationModal
        open={modifyModal}
        handleClose={() => setModifyModal(false)}
        closemodal={() => setModifyModal(false)}
        bgcolor="white"
        width="40vw"
        instruction={
          <div className="d-flex flex-column justify-content-center">
            <div className="d-flex justify-content-between mt-3 mb-3">
              <p className={styles.breadcumb}>
                <EditOutlined
                  style={{ fontSize: "35px", color: "#950303" }}
                  className="me-3"
                />
                <span>Modify Class</span>{" "}
              </p>
            </div>

            <div className="d-flex flex-column justify-content-center align-items-center">
              <ModifyForm
                selectedItem={selectedItem}
                setIsModalOpen={setIsModalOpen}
                setModifyModal={setModifyModal}
                // contact={dataMatch?.contact_name}
                // phone={dataMatch?.fone}
                // oxygen={dataMatch?.oxygen_premium_name}
                // blood={dataMatch?.blood_premium_name}
                // address={dataMatch?.address}
                // city={dataMatch?.city}
                // state={dataMatch?.state}
                // ref_id={dataMatch?.ref_id}
                // note={dataMatch?.note}
                onClickNo={() => setModifyModal(false)}
                onClickYes={() => handleUpdate()}
              />
            </div>
          </div>
        }
      />
    </div>
  );
};

export default CradleRequest;
